export default {
    defaultDomain: 'https://www-qa.burgerking.fr',
    apiBaseUrl: 'https://webapi-qa.burgerking.fr/blossom/api/v13',
    deliveryApiBaseUrl: 'https://webapi-delivery-qa.burgerking.fr/api/v1',
    websocketUrl: 'wss://webapi-qa.burgerking.fr/websocket',
    storageBaseUrl: 'https://bkfstorageqa.blob.core.windows.net',
    woosmapPublicKey: 'woos-300ebf7c-36ff-3101-91bd-a748b493ce84'
}
